
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "TopBarCallToAction",

  setup() {
    const store = useStore();

    const callToAction: any = computed(() => {
      return store.getters.currentUser.call2action;
    });

    const languange: any = computed((): string => {
      return localStorage.getItem("lang") || "ptBR";
    });

    const action = computed(() => {
      let data: any;

      if (!callToAction.value.languages) {
        return {};
      }

      callToAction.value.languages.map((item: any) => {
        if (item.lang === languange.value) {
          data = item;
        }
      });

      return data;
    });

    return {
      action,
      callToAction,
    };
  },
});
